import React from 'react';
import { TileType } from '../types/TileType';
import classNames from 'classnames';
import { TextLabelValue } from '../../../../core/components';

type PropsType = {
  tiles: TileType[];
  columns: number;
};

const Tiles = (props: PropsType) => {
  return (
    <div className="row">
      {props.tiles.map(
        (tile, index: number) =>
          (tile.isVisible || tile.isVisibleOnMobile) && (
            <div
              key={`${index}${tile.label}`}
              className={classNames(
                `col-6 col-sm-${Math.round(12 / props.columns)} mb-2`,
                !tile.isVisible && 'hide-d',
                !tile.isVisibleOnMobile && 'hide-m'
              )}
            >
              <TextLabelValue label={tile.label}>
                {tile.value} {tile.currency}
              </TextLabelValue>
            </div>
          )
      )}
    </div>
  );
};

export default Tiles;
